export default __webpack_public_path__ + "static/media/durango-hosp.3c85be3e.png";